import { render, staticRenderFns } from "./CellRendererBadge.vue?vue&type=template&id=531d3d82&"
import script from "./CellRendererBadge.vue?vue&type=script&lang=js&"
export * from "./CellRendererBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports